














import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import { Quote } from '@/models/quote';
import { QuoteApi } from '@/api/quote-api';
import { ApprovalApi } from '@/api/approval-api';
import { QuoteHistory } from '@/models/quote-history';
import { Forbidden } from '@/models/forbidden-error';
import quoteDetails from '@/components/quote-details.vue';
import { NotFound } from '@/models/not-found-error';
import { Customer } from '@/models/customer';
import { Site } from '@/models/site';
import debounce from 'lodash.debounce';

const approvalApi = new ApprovalApi();
const quoteApi = new QuoteApi();
const userModule = namespace('user');

@Component({
    components: {
        quoteDetails,
    },
})
export default class ViewEnquiry extends Vue {
    public isLoading: boolean = true;
    public quote: Quote | null = null;
    public history: Array<QuoteHistory> = new Array<QuoteHistory>();
    @userModule.Getter('currentCustomer') public currentCustomer: Customer | null;
    @userModule.Getter('currentSite') public currentSite: Site | null;

    @Watch('currentCustomer')
    public async onCustomerChanged(value: Customer): Promise<void> {
        await this.reloadQuoteAsync();
    }
    @Watch('currentSite')
    public async onSiteChanged(value: Site): Promise<void> {
        await this.reloadQuoteAsync();
    }
    public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.reloadQuoteAsync();
        this.isLoading = false;
    }

    private async reloadQuoteAsync(): Promise<void> {
        try {
            const quote = await quoteApi.fetchByIdAsync(this.$route.params.id);
            const history = await quoteApi.fetchHistoryByIdAsync(this.$route.params.id);
            this.quote = quote;
            this.history = history;
        } catch (e) {
            if (e instanceof Forbidden) {
                this.$router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                this.$router.push({ name: 'not-found' });
            }
        }
    }
    private reloadQuoteDebounced = debounce(this.reloadQuoteAsync, 750);

    public async approvalAccepted(id: string): Promise<void> {
        this.isLoading = true;
        await approvalApi.acceptAsync(id);
        this.reloadQuoteDebounced();
        this.isLoading = false;
    }
    public async approvalRejected(id: string): Promise<void> {
        this.isLoading = true;
        await approvalApi.rejectAsync(id);
        this.reloadQuoteDebounced();
        this.isLoading = false;
    }
}
